<template>
  <v-card hover v-if="!loading">
    <v-responsive :gradient="customGradient" :dark="customDark" :height="customHeight">
      <v-container my-0 pb-0>
        <v-layout align-start>
          <v-flex text-xs-left>
            <slot name="header" class="headline"></slot>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container my-0 py-1>
        <v-layout align-center>
          <v-flex text-xs-center>
            <slot></slot>
          </v-flex>
        </v-layout>
      </v-container>
    </v-responsive>
    <v-slide-y-reverse-transition>
      <v-card-text v-show="showSettings">
        <slot name="widget-settings"></slot>
      </v-card-text>
    </v-slide-y-reverse-transition>
    <v-card-actions>
      <v-spacer></v-spacer>
      <slot name="widget-action"></slot>

      <div v-if="hasSettingsSlot">
        <v-btn icon flat @click="showSettings = !showSettings" color="secondary">
          <v-icon small>{{ showSettings ? 'keyboard_arrow_up' : 'settings' }}</v-icon>
        </v-btn>
      </div>
      <div v-if="hasMoreSlot">
        <div class="position-relative-bottom-right">
          <v-dialog max-width="75vw" v-model="dialog">
            <v-btn flat icon slot="activator" color="secondary">
              <v-icon small>mdi-information</v-icon>
            </v-btn>

            <v-card>
              <v-card-text>
                <slot name="widget-more"></slot>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" flat @click="dialog = false">
                  Cerrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ['src', 'gradient', 'height', 'dark', 'light'],
  data() {
    return {
      loading: true,
      customHeight: '',
      customDark: false,
      dialog: false,
      showSettings: false,
    };
  },
  computed: {
    hasActionSlot() {
      return !!this.$slots['widget-action'];
    },
    hasMoreSlot() {
      return !!this.$slots['widget-more'];
    },
    hasSettingsSlot() {
      return !!this.$slots['widget-settings'];
    },
  },
  mounted() {
    this.loading = true;
    if (this.dark) {
      this.customDark = true;
    }
    if (this.gradient) {
      this.customGradient = this.gradient;
    }
    if (this.height) {
      this.customHeight = this.height;
    }

    this.loading = false;
  },
};
</script>

<style lang="scss">
.position-relative-bottom-right {
  position: relative;
  bottom: 0;
  right: 0.5rem;
}
</style>
